<template>
	<div class="">
		<main>
		<section class=" w-full min-h-screen bg-gradient-to-r from-blue-50 to-pink-50 pt-[70px]">
			<img src="../assets/boogi-logo-gray-800.svg" class="h-[36px] mx-auto mb-[60px]">
			<div class="w-full h-screen">
				<div class="flex flex-col justify-center pb-10 sm:mx-auto sm:w-full sm:max-w-md px-4 sm:px-0 text-gray-800">
					<div class="bg-gradient-to-b from-gray-50 to-white px-4 py-5 sm:p-5 rounded-2xl shadow-lg">
						<router-view/>
					</div>
				</div>
			</div>
		</section>
		</main>
	</div>
</template>

<script>
export default {
name: "AuthView"
	
}
</script>
